import { formatIngreso } from "@/lib/leadPeriod";

const APP_LABELS = {
  nombre_completo_ine: "Nombre (INE)", estado_civil: "Estado civil", rfc: "RFC", nacionalidad: "Nacionalidad",
  lugar_nacimiento: "Lugar de nacimiento", nivel_estudios: "Nivel de estudios", dependientes: "Dependientes",
  tipo_vivienda: "Tipo de vivienda", pago_vivienda_mensual: "Pago mensual vivienda", antiguedad_vivienda: "Antigüedad vivienda",
  actividad_economica: "Actividad / puesto", tipo_actividad: "Tipo de actividad", nombre_empresa: "Empresa",
  antiguedad_empleo: "Antigüedad empleo", direccion_empresa: "Dirección empresa", telefono_trabajo: "Teléfono trabajo",
  dado_alta_hacienda: "Alta en Hacienda", ingreso_mensual_promedio: "Ingreso mensual promedio",
  tipo_comprobante: "Comprobante", fecha_ingreso_empresa: "Fecha ingreso empresa",
};
const AUTH_LABELS = {
  banco_autoriza: "Financiera", monto_autorizado: "Monto autorizado", pago_inicial: "Pago inicial",
  mensualidad: "Mensualidad", plazo_meses: "Plazo (meses)", anio_precio_auto: "Año / precio del auto",
  sugerencias: "Sugerencias", banco: "Financiera", motivo: "Motivo",
};
const AUTO_LABELS = { marca: "Marca", anio: "Año", modelo: "Modelo", version: "Versión", transmision: "Transmisión", rango_precio: "Rango de precio" };

const money = (v) => (v || v === 0 ? `$${Number(v).toLocaleString("es-MX")}` : "—");
const show = (v) => (typeof v === "boolean" ? (v ? "Sí" : "No") : v);

export function autoLabel(b) {
  const a = b.auto_en_mente || {};
  const s = [a.marca, a.modelo, a.anio].filter(Boolean).join(" ");
  return b.tiene_auto_en_mente && s ? s : "—";
}

export function AdvisorClientDetail({ b }) {
  const pre = b.prequalification || {};
  const app = b.application || {};
  const auth = b.authorization || {};
  const rej = b.rejection || {};
  return (
    <div className="space-y-2" data-testid="asesor-detail">
      <Block title="Contacto">
        <KV k="Fecha y hora de ingreso" v={formatIngreso(b.created_at)} testId="asesor-detail-ingreso" />
        <KV k="Folio" v={b.folio_cliente} /><KV k="Teléfono" v={b.telefono} /><KV k="Correo" v={b.correo} />
        <KV k="Ciudad" v={b.ciudad} /><KV k="Estatus" v={b.estado} /><KV k="Tipo de unidad" v={b.tipo_unidad} />
        <KV k="Financiera asignada" v={b.banco_asignado} testId="asesor-detail-financiera" />
      </Block>
      {b.tiene_auto_en_mente && (
        <Block title="Auto de interés">{Object.entries(b.auto_en_mente || {}).map(([k, v]) => <KV key={k} k={AUTO_LABELS[k] || k} v={v} />)}</Block>
      )}
      {Object.keys(pre).length > 0 && (
        <Block title="Precalificación">
          <KV k="Edad" v={pre.edad} /><KV k="Tipo de ingreso" v={pre.tipo_ingreso} />
          <KV k="Ingreso mensual" v={money(pre.ingreso_mensual)} /><KV k="Debe a Banco Azteca" v={pre.debe_a_azteca} />
          <KV k="Buró" v={pre.buro} /><KV k="Valor del auto" v={money(pre.valor_auto)} />
          <KV k="Enganche" v={pre.enganche_pct != null ? `${pre.enganche_pct}%` : "—"} /><KV k="Intentos de crédito (3 meses)" v={pre.intentos_credito_3m} />
          {b.match_result?.candidates && <KV k="Financieras posibles" v={b.match_result.candidates.join(", ") || "Ninguna"} />}
        </Block>
      )}
      {Object.keys(app).length > 0 && (
        <Block title="Solicitud completa">
          {Object.entries(app).filter(([k]) => k !== "referencias" && k !== "banco_elegido").map(([k, v]) => <KV key={k} k={APP_LABELS[k] || k} v={show(v)} />)}
          {app.referencias?.map((r, i) => (
            <div key={i} className="mt-2 rounded-sm bg-[#F1F3F3] p-2 text-xs" data-testid={`asesor-ref-${i}`}>
              <p className="mono uppercase text-[#A0553F]">Referencia {i + 1}</p>
              <div>{r.nombre} · {r.telefono} · {r.parentesco}</div>
              <div className="text-[#6B7678]">{r.direccion}</div>
            </div>
          ))}
        </Block>
      )}
      {Object.keys(auth).length > 0 && (
        <Block title="Condiciones autorizadas">{Object.entries(auth).map(([k, v]) => <KV key={k} k={AUTH_LABELS[k] || k} v={show(v)} />)}</Block>
      )}
      {Object.keys(rej).length > 0 && (
        <Block title="Rechazo">{Object.entries(rej).map(([k, v]) => <KV key={k} k={AUTH_LABELS[k] || k} v={show(v)} />)}</Block>
      )}
    </div>
  );
}

function Block({ title, children }) {
  return (
    <div className="mt-4 border-t border-[#3E5641]/10 pt-3">
      <p className="mono mb-2 text-[10px] uppercase tracking-widest text-[#A0553F]">{title}</p>
      <div className="grid gap-x-6 gap-y-1 text-sm md:grid-cols-2">{children}</div>
    </div>
  );
}

function KV({ k, v, testId }) {
  return (
    <div className="flex flex-wrap justify-between gap-2 border-b border-dashed border-[#3E5641]/10 py-1">
      <span className="text-xs text-[#6B7678]">{k}</span>
      <span className="text-right text-[#3E5641] break-words" data-testid={testId}>{v === null || v === undefined || v === "" ? "—" : String(v)}</span>
    </div>
  );
}
